import React from 'react';
import { FlexStyle, View, ViewProps } from 'react-native';
import { DimensionValue } from 'react-native/Libraries/StyleSheet/StyleSheetTypes';
import styled from 'styled-components/native';
import { isDefined } from '@matap/shared';

export interface BoxProps extends ViewProps {
  flexDirection?: FlexStyle['flexDirection'];
  alignItems?: FlexStyle['alignItems'];
  justifyContent?: FlexStyle['justifyContent'];
  flexWrap?: FlexStyle['flexWrap'];
  fullWidth?: boolean;
  flex?: number;
  width?: DimensionValue | undefined;
  height?: DimensionValue | undefined;
  flexGrow?: number;
}
export const Box = React.memo(
  React.forwardRef<View, BoxProps>((props, ref) => {
    return <Component ref={ref} {...props} />;
  }),
);

const Component = styled(View)<BoxProps>`
  ${({ flexDirection }) => flexDirection && `flex-direction:${flexDirection}`};
  ${({ justifyContent }) => justifyContent && `justify-content:${justifyContent}`};
  ${({ alignItems }) => alignItems && `align-items:${alignItems}`};
  ${({ fullWidth }) => fullWidth && `width: 100%;`};
  ${({ flexWrap }) => flexWrap && `flex-wrap:${flexWrap}`};
  ${({ flex }) => isDefined(flex) && `flex:${flex}`};
  ${({ flexGrow }) => isDefined(flexGrow) && `flex-grow:${flexGrow}`};
  ${({ width }) => isDefined(width) && `width:${typeof width === 'string' ? width : `${width}px`}`};
  ${({ height }) => isDefined(height) && `height:${typeof height === 'string' ? height : `${height}px`}`};
  user-select: none;
`;

Box.displayName = 'Box';
